import React from "react";

interface SummaryButtonProps {
  text: string; // required dynamic text
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

const SummaryButton: React.FC<SummaryButtonProps> = ({
  text,
  onClick,
  loading = false,
  disabled = false,
  className = "",
}) => {
  return (
    <div className="px-4 mt-6 text-center">
      <button
        onClick={onClick}
        disabled={disabled || loading}
        className={`summary-btn ${className}`}
      >
        {loading ? "Loading..." : text}
      </button>
    </div>
  );
};

export default SummaryButton;